import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "recenterFilled"
const RecenterFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M15.663 19.212 14.337 20.538 12.937 19.138V22.5H11.064V19.138L9.663 20.538 8.337 19.212 12 15.55zM8.45 12 4.789 15.663 3.462 14.337 4.862 12.937H1.5V11.064H4.862L3.462 9.663 4.788 8.337zM20.538 9.663 19.138 11.063H22.5V12.937H19.138L20.538 14.338 19.212 15.663 15.55 12 19.212 8.337zM12 9.75C13.243 9.75 14.25 10.757 14.25 12S13.243 14.25 12 14.25 9.75 13.243 9.75 12 10.757 9.75 12 9.75M12.938 4.862 14.338 3.462 15.662 4.788 12 8.45 8.337 4.788 9.663 3.462 11.063 4.862V1.5H12.937z" />
        </svg>
      }
    </span>
  )
}
export default RecenterFilledIcon
